import React, {useState, useEffect} from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {Container, Row, Col, Button} from 'reactstrap';
import {connect} from 'react-redux';
import {} from '../../cellcomAbroadBlockSlice';
import images from '../images/images';
import './CancelPackagePopUp.scss';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import './CancelSurfPopUp.scss';
import Lottie from 'react-lottie';
import PaperPlane from '../../../../../animations/paperPlane.json';
import {isMobileOnly} from 'react-device-detect';
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../../utilities/theme/ThemeColorEnum';
export default function CancelSurfPopUp({onClose, removePackage, otpPhone, otpTicketId, getUsageData, getCustomerAbroadUsageDisplay}) {
  const btnTxt = `אשאיר את החסימה`;
  const removeBlockTxt = `הסירו את חסימת גלישה`;
  const header = `הסרת חסימת גלישה`;

  function goBack() {
    onClose();
  }

  async function removeCurrentSurfBlock() {
    const removeSurfSocData = {
      soc: '',
      mobile: otpPhone,
      startDate: '',
      shouldRemoveSurfingBlockSoc: true,
    };
    await removePackage(removeSurfSocData);
    await getCustomerAbroadUsageDisplay({mobile: otpPhone});
    onClose();
  }

  useEffect(() => {
    return () => {
      // TBD change boolean status of setDisplaySuccessfulSurfBlockRemoved to true / false according to result of remove soc then close
      onClose();
    };
  }, []);

  return (
    <div className='surf-pop-up-container'>
      <div className='surf-header'>{header}</div>
      {/* <Lottie options={{animationData: PaperPlane, loop: false}} width={isMobileOnly ? 200 : 250} /> */}
      <ThemedLottie animationData={PaperPlane} color={ThemeColorEnum.PRIMARY} loop={false} width={isMobileOnly ? 200 : 250} />
      <p className='p-txt'>
        <span className='strong'>בכדי להנות מגלישה בחו"ל במסגרת החבילה, </span>
        <br />
        יש לבטל את חסימת הגלישה
      </p>
      <BtnSubmit text={removeBlockTxt} onclick={() => removeCurrentSurfBlock()} />
      <div className='cancel-line' onClick={() => goBack()}>
        {btnTxt}
      </div>
    </div>
  );
}
